import { render, staticRenderFns } from "./point-add.vue?vue&type=template&id=7e4e7ee8&scoped=true&"
import script from "./point-add.vue?vue&type=script&lang=js&"
export * from "./point-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e7ee8",
  null
  
)

export default component.exports